module.exports = __webpack_public_path__ + "static/img/gongao.e36da5bc.jpg";